// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kt-avatar .kt-avatar__upload:hover {
  transition: all 0.3s;
  background-color: #f44336;
  color: #fff;
}

.dorp-zone-media {
  border: 2px dashed #008fc780;
}

.media-files .kt-portlet .kt-portlet__body {
  padding-top: 0
}

.kt-widget__files .kt-widget__media img.images {
  width: 100%;
  height: 150px;
  object-fit: cover
}

.dragItem {
  position: absolute;
  top: 0;
  left: 0;
}

button.btn.not-allowed:hover {
  cursor: not-allowed !important;
}

.theme-scroll {
  height: 40vh !important;
}

 

  

::ng-deep  .mat-mdc-dialog-container{
  height: initial;
  overflow: initial;
}



::ng-deep .mat-dialog-container {
  display: block;
  padding: 24px;
  border-radius: 4px;
  box-sizing: border-box;
  overflow: auto;
  outline: 0;
  width: 100%;
  height: 100%;
  min-height: inherit;
  max-height: inherit
}

@media (-ms-high-contrast:active) {
  .mat-dialog-container {
      outline: solid 1px
  }
}

::ng-deep .mat-dialog-content {
  display: block;
  margin: 0 -24px;
  padding: 0 24px;
  max-height: 65vh;
  overflow: auto;
  -webkit-overflow-scrolling: touch
}

::ng-deep  .mat-dialog-title {
  margin: 0 0 20px;
  display: block
}

::ng-deep  .mat-dialog-actions {
  padding: 8px 0;
  display: flex;
  flex-wrap: wrap;
  min-height: 52px;
  align-items: center;
  margin-bottom: -24px
}

::ng-deep .mat-dialog-actions[align=end] {
  justify-content: flex-end
}

::ng-deep  .mat-dialog-actions[align=center] {
  justify-content: center
}

::ng-deep  .mat-dialog-actions .mat-button-base+.mat-button-base {
  margin-left: 8px
}

::ng-deep  [dir=rtl] .mat-dialog-actions .mat-button-base+.mat-button-base {
  margin-left: 0;
  margin-right: 8px
}



::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  display: block !important;
  /* padding: 24px !important; */
  border-radius: 4px !important;
  box-sizing: border-box !important;
  overflow: auto !important;
  outline: 0 !important;
  width: 100% !important;
  height: 100% !important;
  min-height: inherit !important;
  max-height: inherit !important;
}



.custom-dialog .mat-mdc-dialog-container {
  display: block !important;
  padding: 24px !important;
  border-radius: 4px !important;
  overflow: auto !important;
  height: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/views/media-manager/media-manager.component.css"],"names":[],"mappings":"AAAA;EAEE,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;;;;;AAMA;EACE,eAAe;EACf,iBAAiB;AACnB;;;;AAIA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB;AACF;;AAEA;EACE;MACI;EACJ;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;;;AAIA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;EAC7B,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,8BAA8B;AAChC;;;;AAIA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;AACzB","sourcesContent":[".kt-avatar .kt-avatar__upload:hover {\r\n  -webkit-transition: all 0.3s;\r\n  transition: all 0.3s;\r\n  background-color: #f44336;\r\n  color: #fff;\r\n}\r\n\r\n.dorp-zone-media {\r\n  border: 2px dashed #008fc780;\r\n}\r\n\r\n.media-files .kt-portlet .kt-portlet__body {\r\n  padding-top: 0\r\n}\r\n\r\n.kt-widget__files .kt-widget__media img.images {\r\n  width: 100%;\r\n  height: 150px;\r\n  object-fit: cover\r\n}\r\n\r\n.dragItem {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\nbutton.btn.not-allowed:hover {\r\n  cursor: not-allowed !important;\r\n}\r\n\r\n.theme-scroll {\r\n  height: 40vh !important;\r\n}\r\n\r\n \r\n\r\n  \r\n\r\n::ng-deep  .mat-mdc-dialog-container{\r\n  height: initial;\r\n  overflow: initial;\r\n}\r\n\r\n\r\n\r\n::ng-deep .mat-dialog-container {\r\n  display: block;\r\n  padding: 24px;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n  overflow: auto;\r\n  outline: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  min-height: inherit;\r\n  max-height: inherit\r\n}\r\n\r\n@media (-ms-high-contrast:active) {\r\n  .mat-dialog-container {\r\n      outline: solid 1px\r\n  }\r\n}\r\n\r\n::ng-deep .mat-dialog-content {\r\n  display: block;\r\n  margin: 0 -24px;\r\n  padding: 0 24px;\r\n  max-height: 65vh;\r\n  overflow: auto;\r\n  -webkit-overflow-scrolling: touch\r\n}\r\n\r\n::ng-deep  .mat-dialog-title {\r\n  margin: 0 0 20px;\r\n  display: block\r\n}\r\n\r\n::ng-deep  .mat-dialog-actions {\r\n  padding: 8px 0;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  min-height: 52px;\r\n  align-items: center;\r\n  margin-bottom: -24px\r\n}\r\n\r\n::ng-deep .mat-dialog-actions[align=end] {\r\n  justify-content: flex-end\r\n}\r\n\r\n::ng-deep  .mat-dialog-actions[align=center] {\r\n  justify-content: center\r\n}\r\n\r\n::ng-deep  .mat-dialog-actions .mat-button-base+.mat-button-base {\r\n  margin-left: 8px\r\n}\r\n\r\n::ng-deep  [dir=rtl] .mat-dialog-actions .mat-button-base+.mat-button-base {\r\n  margin-left: 0;\r\n  margin-right: 8px\r\n}\r\n\r\n\r\n\r\n::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\r\n  display: block !important;\r\n  /* padding: 24px !important; */\r\n  border-radius: 4px !important;\r\n  box-sizing: border-box !important;\r\n  overflow: auto !important;\r\n  outline: 0 !important;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  min-height: inherit !important;\r\n  max-height: inherit !important;\r\n}\r\n\r\n\r\n\r\n.custom-dialog .mat-mdc-dialog-container {\r\n  display: block !important;\r\n  padding: 24px !important;\r\n  border-radius: 4px !important;\r\n  overflow: auto !important;\r\n  height: 100% !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
